// extracted by mini-css-extract-plugin
module.exports = {"root":"userlayout_root_266j2","user":"userlayout_user_1nZMF","main":"userlayout_main_3El6n"};